export const enum ROUTE_AVATAR_UPLOAD {
  avatarUpload = '/avatar-upload',
}
